import { AnyAction, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { isFulfilled, isRejected } from '@reduxjs/toolkit'
import { NotificationsState } from './types'
import crsNotifications from '../../api/crs/notifications'
import ccsNotifications from '../../api/ccs/notifications'

const allApiNotifications = [...crsNotifications, ...ccsNotifications]
const isEndpointAction = (endpoint: typeof allApiNotifications[0]['endpoint'], action: AnyAction) =>
  endpoint['matchFulfilled'](action) || endpoint['matchRejected'](action)
const composeIsApiNotificationAction = (notifications: typeof allApiNotifications) => (action: AnyAction) =>
  notifications.some(({ endpoint }) => isEndpointAction(endpoint, action))
const isCrsAction = composeIsApiNotificationAction(crsNotifications)
const isCcsAction = composeIsApiNotificationAction(ccsNotifications)
const isApiNotificationAction = (action: AnyAction) => isCrsAction(action) || isCcsAction(action)

const getApiKey = (action: AnyAction) => {
  if (isCrsAction(action)) return 'crs'
  if (isCcsAction(action)) return 'ccs'
  return undefined
}

const getVariant = (action: AnyAction) => {
  if (isFulfilled(action)) return 'success'
  if (isRejected(action)) return 'error'
  return undefined
}

const initialState: NotificationsState = []

export const name = 'notifications'

const notificationsSlice = createSlice({
  name,
  initialState,
  reducers: {
    removeNotification: (state, { payload }: PayloadAction<string | number>) =>
      state.filter((notification) => notification.key !== payload),
  },
  extraReducers: (builder) => {
    builder.addMatcher(isApiNotificationAction, (state, action) => {
      const notification = allApiNotifications.find(({ endpoint }) => isEndpointAction(endpoint, action))
      if (!notification) return
      const { tKey: suffix } = notification
      const variant = getVariant(action)
      state.push({
        variant,
        tKey: `${getApiKey(action)}.${getVariant(action)}.${suffix}`,
        key: new Date().getTime() + Math.random(),
      })
    })
  },
})

export const { removeNotification } = notificationsSlice.actions

export default notificationsSlice.reducer
